import { Home, Hammer, Ruler, HardHat, ClipboardList, ShieldCheck, Trees } from "lucide-react";
import PageHero from "@/components/PageHero";
import { CTABand } from "@/pages/About";
import { SERVICES, ASSETS } from "@/data";

const ICONS = { Home, Hammer, Ruler, HardHat, ClipboardList, ShieldCheck, Trees };

const PROCESS = [
  { step: "01", title: "Consultation", desc: "We listen to your vision, budget and timeline." },
  { step: "02", title: "Design & Plan", desc: "We turn ideas into buildable, detailed plans." },
  { step: "03", title: "Build", desc: "Skilled crews execute with precision and care." },
  { step: "04", title: "Walkthrough", desc: "We hand over the keys to a home built to last." },
];

export default function Services() {
  return (
    <main data-testid="services-page">
      <PageHero
        eyebrow="Services"
        title={<>WHAT WE<br />BUILD.</>}
        subtitle="We do custom homes, remodels and outdoor living — delivering craftsmanship that stands the test of time."
        image={ASSETS.framing}
      />

      {/* Services grid */}
      <section className="bg-cream" style={{ backgroundColor: "var(--l3-cream)" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => {
              const Icon = ICONS[s.icon] || Home;
              return (
                <div
                  key={s.title}
                  data-testid={`service-${i}`}
                  className="bg-white/70 border border-[#d8ccb2] rounded-sm p-8 hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-14 h-14 flex items-center justify-center rounded-sm mb-5" style={{ backgroundColor: "var(--l3-wood-dark)" }}>
                    <Icon size={28} strokeWidth={1.6} style={{ color: "var(--l3-gold)" }} />
                  </div>
                  <h3 className="font-cond font-semibold tracking-wide text-xl mb-3" style={{ color: "var(--l3-wood-dark)" }}>
                    {s.title.toUpperCase()}
                  </h3>
                  <p className="text-[15px] leading-relaxed" style={{ color: "#5b4f3d" }}>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="bg-wood-dark" style={{ backgroundColor: "var(--l3-wood-dark)" }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="text-center mb-14">
            <p className="font-cond tracking-[0.3em] text-gold text-sm mb-3">HOW WE WORK</p>
            <h2 className="font-display heading-distress text-4xl sm:text-5xl">OUR PROCESS</h2>
          </div>
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {PROCESS.map((p, i) => (
              <div key={p.step} data-testid={`process-${i}`} className="relative">
                <div className="font-display text-6xl leading-none mb-4" style={{ color: "rgba(184,136,74,0.35)" }}>{p.step}</div>
                <h3 className="font-cond font-semibold tracking-wide text-lg mb-2" style={{ color: "var(--l3-cream)" }}>{p.title.toUpperCase()}</h3>
                <p className="text-white/60 text-[15px] leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTABand />
    </main>
  );
}
